<template>
  <SdzModal
    ref="modal"
    @close="close"
    :close-icon="true"
    :width="$isMobile() ? '400' : '550'"
    custom-class="reprove-modal"
    hide-confirm-button
    hide-cancel-button
  >
    <v-layout
      align-center
      column
      justify-center
      wrap
      class="pt-5 pb-2 px-5"
    >
      <img
        :src="require(`@/assets/images/icons/info.svg`)"
        class="mb-4"
        width="70"
      >
      <span class="modal-title">
        Tem certeza que deseja revisar essa nota?
      </span>
      <span class="modal-text">
        O serviço de validação da nota ja deve ter sido ajustado para que o usuario possa receber os dados atualizados.
      </span>
    </v-layout>
    <template #buttons>
      <v-btn
        @click="close"
        color="primary"
        class="mb-3"
        outline
        flat
        large
      >
        Cancelar
      </v-btn>
      <v-btn
        @click="approve"
        color="primary"
        class="mb-3"
        large
      >
        Sim, ajustes realizados
      </v-btn>
    </template>
  </SdzModal>
</template>

<script>
import SdzModal from '@/components/sdz/SdzModal.vue'
import { approveInvoiceReview } from '@/services/containers/partners/invoices'

export default {
  name: 'ApproveInvoiceReviewModal',
  components: {
    SdzModal
  },
  props: {
    reviewId: {
      type: String,
      required: true
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$emit('close')
      this.$refs.modal.close()
    },
    async approve() {
      try {
        await approveInvoiceReview(this.reviewId)
        this.$toast('Solicitação aprovada com sucesso', 'green')
        this.$emit('reviewApproved')
        this.$refs.modal.close()

      } catch (error) {
        this.$toast(error.response.data.message, 'red')
        this.close()
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .reprove-modal {
    .modal-title {
      font-size: 28px;
      color: var(--v-gray-darken2);
      text-align: center;
    }

    .modal-text {
      font-size: 18px;
      color: var(--v-gray-darken2);
    }
    .reprove-form {
      margin-top: 24px;
      width: 100%;
    }

    .counter {
      font-size: 12px;
      color: var(--v-gray-darken2)
    }
  }
</style>